import { over } from "lodash"

const autoCompleteStyles = {
   // Previous Name WarehouseIM
   STYLE_ONE: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         borderRadius: "4px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "50px",
         borderRadius: "10px",
         background: "#EEEEEE",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
   },

   //Previous Name IMRequests
   STYLE_TWO: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         background: "#FFFFFF",
         border: "1px solid #CED4DA",
         borderRadius: "4px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "45px",
         borderColor: "#9d9d9d",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
   },

   //Previous Name AddNewItemSelectStyling
   STYLE_THREE: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         background: "#FFFFFF",
         border: "1px solid #CED4DA",
         borderRadius: "4px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "45px",
         borderColor: "#9d9d9d",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
      // option: styles => {
      //    return {
      //       ...styles,
      //    }
      // },
      menuPortal: base => ({ ...base, zIndex: 9999 }),
   },

   //Previous Name AutoCompleteStyling
   STYLE_FOUR: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         background: "#FFFFFF",
         border: "1px solid #CED4DA",
         borderRadius: "4px",
         fontSize: "13px",
         fontWeight: 400,
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "40px",
         borderColor: "#9d9d9d",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      placeholder: provided => ({
         ...provided,
         fontSize: "13px",
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
      // option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      //    return {
      //       ...styles,
      //       backgroundColor: isFocused ? "#999999" : null,
      //       color: "#333333",
      //       "&:hover": {
      //          backgroundColor: "#999999",
      //       },
      //    }
      // },
      menuPortal: base => ({ ...base, zIndex: 9999 }),
   },

   //Previous Name WarehouseIMHeaderStatus
   STYLE_FIVE: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         background: "#EEEEEE",
         borderRadius: "10px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "45px",
         borderColor: "#9d9d9d",
         borderRadius: "10px",
         border: state.isFocused ? 0 : 0,
         background: "#EEEEEE",
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
   },

   //Previous Name AdminAppSelectStyles
   STYLE_SIX: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         borderRadius: "4px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "50px",
         borderRadius: "10px",
         background: "#EEEEEE",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
   },

   // STYLE_SIX: {
   //    container: provided => ({
   //       display: "inline-block",
   //       position: "relative",
   //       width: "100%",
   //       borderRadius: "4px",
   //       ...provided,
   //    }),
   //    control: (provided, state) => ({
   //       ...provided,
   //       minHeight: "50px",
   //       borderRadius: "10px",
   //       background: "#EEEEEE",
   //       border: state.isFocused ? 0 : 0,
   //       boxShadow: state.isFocused ? 0 : 0,
   //       "&:hover": {
   //          borderColor: "#9d9d9d",
   //       },
   //    }),
   // },

   STYLE_SEVEN: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "80px",
         fontSize: "13px",
         ...provided,
      }),
      control: (base, state) => ({
         ...base,
         boxShadow: "none",
         borderColor: state.isFocused ? "#ccc" : base.borderColor,
         "&:hover": {
            borderColor: "#aaa",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
      // option: base => ({
      //    ...base,
      //    fontSize: "12px",
      // }),
      indicatorSeparator: () => ({
         display: "none",
      }),

      menuPortal: base => ({ ...base, zIndex: 9999 }),
   },
   STYLE_EIGHT: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         background: "#FFFFFF",
         border: "1px solid #CED4DA",
         borderRadius: "4px",
         fontSize: "13px",
         fontWeight: 400,
         minHeight: "40px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "40px",
         height: "40px",
         minHeight: "max-content",
         borderColor: "#9d9d9d",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      placeholder: provided => ({
         ...provided,
         fontSize: "13px",
      }),
      option: (provided, state) => ({
         ...provided,
         color: "black !important",
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),
      // option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      //    return {
      //       ...styles,
      //       backgroundColor: isFocused ? "#999999" : null,
      //       color: "#333333",
      //       "&:hover": {
      //          backgroundColor: "#999999",
      //       },
      //    }
      // },
      menuPortal: base => ({ ...base, zIndex: 9999 }),
   },
   STYLE_NINE: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         background: "#FFFFFF",
         border: "1px solid #CED4DA",
         borderRadius: "4px",
         fontSize: "13px",
         fontWeight: 400,
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "40px",
         borderColor: "#9d9d9d",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      placeholder: provided => ({
         ...provided,
         fontSize: "13px",
      }),
      option: (provided, state) => ({
         ...provided,
         background: state.isSelected
            ? "#2980b9"
            : state.isFocused
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            background: !state.isSelected && "#dcefff",
         },
      }),

      menuList: provided => ({
         ...provided,
         maxHeight: "150px",
         overflowY: "auto",
      }),
      menuPortal: base => ({ ...base, zIndex: 9999 }),
   },

   STYLE_TEN: {
      container: provided => ({
         display: "inline-block",
         position: "relative",
         width: "100%",
         borderRadius: "4px",
         ...provided,
      }),
      control: (provided, state) => ({
         ...provided,
         minHeight: "50px",
         borderRadius: "10px",
         background: "#EEEEEE",
         border: state.isFocused ? 0 : 0,
         boxShadow: state.isFocused ? 0 : 0,
         cursor: "pointer",
         "&:hover": {
            borderColor: "#9d9d9d",
         },
      }),
      option: (provided, state) => ({
         ...provided,
         cursor: state.isDisabled ? "not-allowed" : "pointer",
         backgroundColor: state.isDisabled
            ? "#f5f5f5"
            : state.isSelected
            ? "#2980b9"
            : state.isFocused && !state.isDisabled
            ? "#dcefff"
            : "#fff",
         color: state.isSelected ? "#fff !important" : "#333",
         "&:hover": {
            backgroundColor: state.isDisabled
               ? "#f5f5f5"
               : !state.isSelected && "#dcefff",
         },
      }),
      menuList: provided => ({
         ...provided,
         paddingTop: 0,
      }),
      menuPortal: base => ({ ...base, zIndex: 9999 }),
   },
}

export default autoCompleteStyles
